import { render } from "./Printable.vue?vue&type=template&id=5ec07146"
import script from "./Printable.vue?vue&type=script&lang=js"
export * from "./Printable.vue?vue&type=script&lang=js"

import "./Printable.vue?vue&type=style&index=0&id=5ec07146&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__